import { useState, useEffect } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center px-6">
      <div className="text-center">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="mb-6 flex justify-center">
            <img 
              src="https://static.readdy.ai/image/46e04b8c96e08f93680e66fd759611e1/c3fcb5290cf7c98706a8bcbdc87271f6.png" 
              alt="HigherEX"
              className="w-full max-w-2xl h-auto"
            />
          </div>
          
          <p
            className="text-lg md:text-xl text-white/60 mb-12 tracking-[0.15rem] font-light"
            style={{ fontWeight: 300 }}
          >
            Underground Hip-Hop Music Producer, MC, DJ, Archivist
          </p>
        </div>
      </div>
    </section>
  );
}
